export type LocalePrefix = 'as-needed' | 'always' | 'never';

const localePrefix: LocalePrefix = 'as-needed';
const directusUrl = process.env.DIRECTUS_URL as string;
const directusPreviewUrl = process.env.DIRECTUS_PREVIEW_URL as string;
const directusFormsFilesFolderId = process.env.DIRECTUS_FORMS_FILES_FOLDER_ID as string;
const directusJobsFilesFolderId = process.env.DIRECTUS_JOBS_FILES_FOLDER_ID as string;
const directusPublicUrl = process.env.NEXT_PUBLIC_DIRECTUS_URL as string;
const directusBoUrls = (process.env.DIRECTUS_BO_URL as string || 'https://bo.ffbb.com,https://bo.ffbb.app').split(',').filter(Boolean);
const directusStaticsUrl = process.env.NEXT_PUBLIC_DIRECTUS_STATICSURL as string || 'https://statics.ffbb.app';
const geniusSportsBaseUrl = 'https://fibalivestats.dcd.shared.geniussports.com/u/FFBB';
const nextIntlLocalePrefix = process.env.NEXT_PUBLIC_LOCALE_PREFIX as string;
const meilisearchPublicUrl = process.env.NEXT_PUBLIC_MEILISEARCH_API_URL as string;
const directusToken = process.env.DIRECTUS_TOKEN as string;
const websiteBaseUrl = process.env.WEBSITE_BASE_URL || 'https://www.ffbb.com';
const websiteBasePublicUrl = process.env.NEXT_PUBLIC_WEBSITE_BASE_URL || 'https://www.ffbb.com';
const competitionsBaseUrl =
  process.env.NEXT_PUBLIC_COMPETITIONS_BASE_URL || 'https://competitions.ffbb.com';
const websiteTitle = process.env.WEBSITE_TITLE || 'FFBB - Fédération Française de Basket-Ball';
const sentryDsn = process.env.SENTRY_DSN;
const sentryDsnPublicUrl = process.env.NEXT_PUBLIC_SENTRY_DSN;
const searchIndexGlobal =
  (process.env.NEXT_PUBLIC_MEILISEARCH_GLOBAL_INDEX as string) || 'ffbbsite_global';
const searchIndexPages =
  (process.env.NEXT_PUBLIC_MEILISEARCH_PAGES_INDEX as string) || 'ffbbsite_pages';
const searchIndexNews =
  (process.env.NEXT_PUBLIC_MEILISEARCH_NEWS_INDEX as string) || 'ffbbsite_news';
const searchIndexPhotos =
  (process.env.NEXT_PUBLIC_MEILISEARCH_PHOTOS_INDEX as string) || 'ffbbnational_galeries';
const searchIndexVideos =
  (process.env.NEXT_PUBLIC_MEILISEARCH_VIDEOS_INDEX as string) || 'youtube_videos';
const searchIndexAssets =
  (process.env.NEXT_PUBLIC_MEILISEARCH_ASSETS_INDEX as string) || 'directus_files';
const searchIndexFaq = (process.env.NEXT_PUBLIC_MEILISEARCH_FAQ_INDEX as string) || 'ffbbsite_faq';
const searchIndexJobs = (process.env.NEXT_PUBLIC_MEILISEARCH_JOBS_INDEX as string) || 'ffbbsite_jobs';
const searchIndexFormations =
  (process.env.NEXT_PUBLIC_MEILISEARCH_FORMATIONS_INDEX as string) || 'ffbbserver_formations';
const searchIndexOrganismes =
  (process.env.NEXT_PUBLIC_MEILISEARCH_ORGANISMES_INDEX as string) || 'ffbbserver_organismes';
const gtmId = process.env.GTM_ID as string;
const previewToken = (process?.env?.NEXT_PREVIEW_SECRET_TOKEN as string) || 'secret';
const nextNewsStaticCount = process.env.NEXT_STATIC_GENERATION_COUNT_NEWS || '';
const meilisearchCustomMenuLimit = 1000;
const findWidgetUrl =
  process?.env?.NEXT_PUBLIC_FIND_WIDGET_URL ||
  'https://statics.ffbb.app/static/js/ffbb-search-v0.1.2.js';

export const AppConfig = {
  defaultLocale: 'fr',
  directusFormsFilesFolderId,
  directusJobsFilesFolderId,
  directusUrl: directusUrl || directusPublicUrl,
  directusPreviewUrl,
  directusPublicUrl,
  directusBoUrls,
  directusStaticsUrl,
  directusToken,
  geniusSportsBaseUrl,
  gtmId,
  locales: ['fr'],
  localePrefix,
  meilisearchPublicUrl,
  nextIntlLocalePrefix,
  nextNewsStaticCount,
  sentryDsn,
  sentryDsnPublicUrl,
  searchIndexGlobal,
  searchIndexPages,
  searchIndexNews,
  searchIndexPhotos,
  searchIndexVideos,
  searchIndexAssets,
  searchIndexFaq,
  searchIndexJobs,
  searchIndexFormations,
  searchIndexOrganismes,
  websiteBaseUrl,
  websiteBasePublicUrl,
  competitionsBaseUrl,
  websiteTitle,
  previewToken,
  meilisearchCustomMenuLimit,
  findWidgetUrl,
};
